<div
  class="bg-standard-background flex w-full overflow-hidden rounded-lg border-1 shadow-lg">
  <ul class="flex flex-col">
    @for (item of subMenuItems; track $index) {
      <li
        tabindex="0"
        awHoverHighlight
        (onHover)="setHighlightedItem($event, $index)"
        class="hover:bg-standard-hover-main flex cursor-pointer flex-row items-center text-base"
        (click)="onSubmenuClick.emit(item.action)"
        (keydown.enter)="onSubmenuClick.emit(item.action)">
        <span class="mx-5 my-3 flex">{{ item.text }}</span>
      </li>
    }
  </ul>
</div>
